module.exports = __webpack_public_path__ + "static/img/logo.f62a2b47.png";